var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"margin-bottom":"10px"}}),_vm._v(" "),_c('mytable',{attrs:{"tableColums":_vm.tableColums_getHuBeiPoints,"api":"getHuBeiPoints","xupdateapi":"updateSysKeyProject","height":_vm.H-165}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c4423a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data/PointsDiy.vue
// module id = null
// module chunks = 